module.exports = __webpack_public_path__ + "media/npc_dota_hero_brewmaster.da5b25e2.webm";